// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__iilet","modalcont":"Modal_modalcont__uzygJ","close":"Modal_close__7DVhk","content":"Modal_content__jjIa1","backdrop":"Modal_backdrop__iW0lM"};